import { z } from 'zod';
import { FLAG_NAMES, type FlagName } from './registry.ts';

export type FlagValues = Readonly<Record<FlagName, boolean>>;

const flagValuesSchema = z.strictObject(
  Object.fromEntries(FLAG_NAMES.map((name) => [name, z.boolean()])) as Record<FlagName, z.ZodBoolean>,
);

const parsedJson = (raw: string): unknown => {
  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
};

export const flagValuesFrom = (raw: string): FlagValues | undefined => {
  const result = flagValuesSchema.safeParse(parsedJson(raw));
  return result.success ? result.data : undefined;
};
